import { PRODUCT_IDS, TOOL_IDS } from '@adsk/alloy-provider';

import { LAYOUTS } from '../../types';

export const ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG = {
  scope: 'accFilesExtraction',
  layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  modulePath: './FilesExtractionFlow',
  layoutProps: {
    currentToolId: TOOL_IDS.DOCUMENTS,
    currentProductId: PRODUCT_IDS.BUILD,
    renderTopNavigation: () => null,
    renderSideNavigation: () => null,
  },
};
